import html2canvas from "html2canvas";
import JSZip from "jszip";
import {saveAs} from "file-saver";

export const captureDivsToPNG = async (parentElement: HTMLElement) => {
  if (!parentElement) {
    console.error("Parent element not provided!");
    return;
  }

  const zip = new JSZip();
  const divs = Array.from(parentElement.children)
    .filter(el => el.tagName === "DIV") as HTMLElement[];

  if (divs.length === 0) {
    console.warn("No direct child divs found inside the parent!");
    return;
  }

  for (let i = 0; i < divs.length; i++) {
    const div = divs[i];

    try {
      // 📸 Capture using html2canvas
      const canvas = await html2canvas(div, {
        backgroundColor: null,
        useCORS: true,
        removeContainer: true,
        scale: 2, // High resolution
      });

      const pngData = canvas.toDataURL("image/png");
      zip.file(`div-${i + 1}.png`, pngData.split(",")[1], {base64: true});
    } catch (error) {
      console.error(`❌ Failed to capture div ${i + 1}:`, error);
    }
  }

  if (Object.keys(zip.files).length === 0) {
    console.error("ZIP file is empty. No images were captured.");
    return;
  }

  // 🔥 Generate ZIP and trigger download
  const zipBlob = await zip.generateAsync({type: "blob"});
  saveAs(zipBlob, `character-attribute-screens-${new Date().toISOString()}.zip`);
};
